import { IMapLayerSource, IMapLayer } from "@/components/map/types";
import { createDate } from "@/common/utils";

export type EEcoPlantType = "cassava" | "maize" | "sugarcane" | "rice";
export const PLANT_NAME = {
  cassave: 'มันสำปะหลัง',
  maize: 'ข้าวโพด',
  sugarcane: 'อ้อย',
  rice: 'ข้าว'
};
export const MONTHS = [
    'ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'
  ];

export const LEGEND08: IMapLayer[] = [{
    title: '(เริ่มปลูก / อายุ)',
    style: {
      background: 'none'
    }
  },{
    title: 'weeks / 2 สัปดาห์',
    style: {
      background:'#006100'
    }
  },{
    title: 'weeks / 4 สัปดาห์',
    style: {
      background:'#498A00'
    }
  },{
    title: 'weeks / 6 สัปดาห์',
    style: {
      background:'#8BB500'
    }
  },{
    title: 'weeks / 8 สัปดาห์',
    style: {
      background:'#D6E600'
    }
  },{
    title: 'weeks / 10 สัปดาห์',
    style: {
      background:'#FFE500'
    }
  },{
    title: 'weeks / 12 สัปดาห์',
    style: {
      background:'#FFA600'
    }
  },{
    title: 'weeks / 14 สัปดาห์',
    style: {
      background:'#FF6F00'
    }
  },{
    title: 'weeks / 16 สัปดาห์',
    style: {
      background:'#FF2200'
    }
  }];

export const LEGEND24: IMapLayer[] = [{
    title: '(เริ่มปลูก)',
    style: {
      background: 'none'
    }
  },{
    style: {
      background:'#006100'
    }
  },{
    style: {
      background:'#186900'
    }
  },{
    style: {
      background:'#317900'
    }
  },{
    style: {
      background:'#428600'
    }
  },{
    style: {
      background:'#529200'
    }
  },{
    style: {
      background:'#6BA200'
    }
  },{
    style: {
      background:'#7BAE00'
    }
  },{
    style: {
      background:'#94BE00'
    }
  },{
    style: {
      background:'#ADCB00'
    }
  },{
    style: {
      background:'#BDDB00'
    }
  },{
    style: {
      background:'#DEEB00'
    }
  },{
    style: {
      background:'#F7F700'
    }
  },{
    style: {
      background:'#FFFB00'
    }
  },{
    style: {
      background:'#FFE700'
    }
  },{
    style: {
      background:'#FFD700'
    }
  },{
    style: {
      background:'#FFC300'
    }
  },{
    style: {
      background:'#FFAE00'
    }
  },{
    style: {
      background:'#FF9E00'
    }
  },{
    style: {
      background:'#FF8E00'
    }
  },{
    style: {
      background:'#FF7900'
    }
  },{
    style: {
      background:'#FF6500'
    }
  },{
    style: {
      background:'#FF5500'
    }
  },{
    style: {
      background:'#FF4100'
    }
  },{
    style: {
      background:'#FF2200'
    }
  }];

export const LEGEND_STAGE = {
    rice: [{
        // all title will be replaced
        title: 'ระยะกล้า (2-4 สัปดาห์)',
        style: {
          background:'#498a00'
        }
      },{
        title: 'ระยะแตกกอ (6-8 สัปดาห์)',
        style: {
          background:'#ffeb3b'
        }
      },{
        title: 'ระยะออกดอก (10-12 สัปดาห์)',
        style: {
          background:'#ff9800'
        }
      },{
        title: 'ระยะเก็บเกี่ยว (14-16 สัปดาห์)',
        style: {
          background:'#ff2200'
        }
      }],
    maize: [{
        // all title will be replaced
        title: 'ระยะเจริญเติบโต (2-6 สัปดาห์)',
        style: {
          background:'#498a00'
        }
      },{
        title: 'ระยะออกดอก (8 สัปดาห์)',
        style: {
          background:'#ffeb3b'
        }
      },{
        title: 'ระยะสะสมน้ำหนักเมล็ด (10-12 สัปดาห์)',
        style: {
          background:'#ff9800'
        }
      },{
        title: 'ระยะเก็บเกี่ยว (14-16 สัปดาห์)',
        style: {
          background:'#ff2200'
        }
      }],
    sugarcane: [{
        // all title will be replaced
        title: 'ระยะงอก (2-8 สัปดาห์)',
        style: {
          background:'#498a00'
        }
      },{
        title: 'ระยะแตกกอ (10-12 สัปดาห์)',
        style: {
          background:'#ffeb3b'
        }
      },{
        title: 'ระยะยืดปล้อง (14-32 สัปดาห์)',
        style: {
          background:'#ff9800'
        }
      },{
        title: 'ระยะสุกแก่ (36-48 สัปดาห์)',
        style: {
          background:'#ff2200'
        }
      }],
    cassava: [{
        // all title will be replaced
        title: 'ระยะงอก (2-4 สัปดาห์)',
        style: {
          background:'#498a00'
        }
      },{
        title: 'ระยะพัฒนาทรงพุ่ม (6-12 สัปดาห์)',
        style: {
          background:'#ffeb3b'
        }
      },{
        title: 'ระยะสะสมอาหาร (14-40 สัปดาห์)',
        style: {
          background:'#ff9800'
        }
      },{
        title: 'ระยะพักตัว (42-48 สัปดาห์)',
        style: {
          background:'#ff2200'
        }
      }]
  };

export const LEGEND_OVERALL = {
    rice: {
        background: 'rgba(255,255,102,0.8)'
      },
    maize: {
        background: 'rgba(255,102,102,0.8)'
      },
    sugarcane: {
        background: 'rgba(0,148,133,0.8)'
      },
    cassava: {
        background: 'rgba(152,102,52,0.8)'
      }
  };

export const LEGEND_WATER_USE = [{
  title: ['0-300','cubicMeterPerRai'],
  style: {
    background: '#f0f921'
  }
},{
  title: ['300-600','cubicMeterPerRai'],
  style: {
    background: '#f89541'
  }
},{
  title: ['600-900','cubicMeterPerRai'],
  style: {
    background: '#cb4778'
  }
},{
  title: ['moreThan','&s','900','cubicMeterPerRai'],
  style: {
    background: '#0d0887'
  }
}]

export const MAP_SOURCES: {[key:string] : IMapLayerSource } = {
  ecoplant: {
    service: 'WMS',
    serverType: 'geoserver',
    params: {
      //'TILED': true, //dont do this, it cachesssss!
      'LAYERS': 'ecoplant:rice_01' //workspace_name:layer_name
    },
    //useGwc: true, //geoserver 2.12 has bug in GeoWebCache
    visible: true, //display it after added to map
    zIndex: 0
  },
  adminBoundaries: {
    service: 'WMS',
    serverType: 'geoserver',
    params: {
      //'TILED': true, //dont do this, it cachesssss!
      'LAYERS': 'gisagro:admin_boundaries' //workspace_name:layer_name
    },
    visible: true,
    zIndex: 10
  },
  irrigationProjectArea: {
    service: 'WMS',
    serverType: 'geoserver',
    params: {
      //'TILED': true, //dont do this, it cachesssss!
      'LAYERS': 'gisagro:irrigation_project' //workspace_name:layer_name
    },
    visible:false,
    zIndex: 10
  },
  irrigationProjectName: {
    service: 'WMS',
    serverType: 'geoserver',
    params: {
      TILED: false,
      LAYERS: 'gisagro:irrigation_project_name'
    },
    visible:false,
    zIndex: 10
  },
  watershed: {
    service: 'WMS',
    serverType: 'geoserver',
    params: {
      //'TILED': true, //dont do this, it cachesssss!
      'LAYERS': 'gisagro:watershed' //workspace_name:layer_name
    },
    visible:false,
    zIndex: 1
  },
  watershedName: {
    service: 'WMS',
    serverType: 'geoserver',
    params: {
      TILED: false,
      LAYERS: 'gisagro:watershed_name'
    },
    visible:false,
    zIndex: 1
  },
  thungkula: {
    service: 'WMS',
    serverType: 'geoserver',
    params: {
      TILED: false,
      LAYERS: 'gisagro:thungkula'
    },
    visible:false,
    zIndex: 20
  }
};
/*
export const xxxIRRIGATION_AREA: IMapLayer[] = [{
    uri: '01',
    title: 'สำนักชลประทานที่ 01',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '02',
    title: 'สำนักชลประทานที่ 02',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '03',
    title: 'สำนักชลประทานที่ 03',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '04',
    title: 'สำนักชลประทานที่ 04',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '05',
    title: 'สำนักชลประทานที่ 05',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '06',
    title: 'สำนักชลประทานที่ 06',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '07',
    title: 'สำนักชลประทานที่ 07',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '08',
    title: 'สำนักชลประทานที่ 08',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '09',
    title: 'สำนักชลประทานที่ 09',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '10',
    title: 'สำนักชลประทานที่ 10',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '11',
    title: 'สำนักชลประทานที่ 11',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '12',
    title: 'สำนักชลประทานที่ 12',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '13',
    title: 'สำนักชลประทานที่ 13',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '14',
    title: 'สำนักชลประทานที่ 14',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '15',
    title: 'สำนักชลประทานที่ 15',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '16',
    title: 'สำนักชลประทานที่ 16',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  },{
    uri: '17',
    title: 'สำนักชลประทานที่ 17',
    type: 'radio',
    checked: false,
    style: {
      border: '1px solid #1E90FF',
      background: '#87CEFA'
    }
  }];*/

export const DOWNLOADS: IMapLayer[] = [{
    title: 'downloadShapeFile'
  },{
    title: 'downloadMapFile'
  },{
    title: 'downloadReportFile'
  },{
    title: 'downloadRIDFile'
  },{
    title: 'downloadRiceDisaster'
  }];

export const BASEMAP_LAYERS: IMapLayer[] = [{
    header: 'baseLayers',
    children: [{
        title: 'adminArea',
        mapSources: [MAP_SOURCES.adminBoundaries],
        geomType: 'Line',
        type: 'checkbox',
        checked: true,
        visible: true,
        active: true,
        image: '/static/images/legend-boundary.svg',
        dense: true,
        showDivider: false,
        children: [{
            title: 'country',
            image: '/static/images/legend-boundary-country.svg'
          },{
            title: 'province',
            image: '/static/images/legend-boundary-changwat.svg'
          },{
            title: 'county',
            image: '/static/images/legend-boundary-amphoe.svg'
          },{
            title: 'town',
            image: '/static/images/legend-boundary-tambon.svg'
          },{
            title: 'shoreLine',
            image: '/static/images/legend-boundary-shoreline.svg'
          }]
      },{
        title: 'irrigationArea',
        mapSources: [
          MAP_SOURCES.irrigationProjectName,
          MAP_SOURCES.irrigationProjectArea
        ],
        geomType: 'Polygon',
        visible: false,
        type: 'checkbox',
        checked: false,
        style: {
          border: '1px solid #0000ff'
        }
      },{
        title: 'watershed',
        mapSources: [
          MAP_SOURCES.watershedName,
          MAP_SOURCES.watershed
        ],
        geomType: 'Polygon',
        visible: false,
        type: 'checkbox',
        checked: false,
        style: {
          border: '1px dashed #0000ff'
        }
      },{
        title: 'thungkula',
        mapSources: [
          MAP_SOURCES.thungkula
        ],
        geomType: 'Polygon',
        visible: false,
        type: 'checkbox',
        checked: false,
        style: {
          //background: 'rgba(244,208,63,0.5)',
          border: '2px solid #ffff00'
        }
      }]
  }];

function timeText(year:number, month:number, date:number) : string {
  let mm = ('0' + (month + 1)).slice(-2);
  let dd = ('0' + date).slice(-2);
  return year + mm + dd;
}

export function getPresentPeriod() : string {
  let today = new Date();
  let yy = today.getFullYear();
  let mm = today.getMonth();
  let dd = today.getDate();
  if (dd<=15) {
    today = new Date(yy, mm, 0);
    yy = today.getFullYear();
    mm = today.getMonth();
    dd = today.getDate();
    return '16-' + dd + ' ' + MONTHS[mm] + ' ' + (yy + 543);
  } else {
    return '01-15 ' + MONTHS[mm] + ' ' + (yy + 543);
  }
};

export function getCropLayers(crop, activePeriod?:number) : IMapLayer {
  let layers: IMapLayer[] = []; //MAP_LAYERS;
  let layer: IMapLayer = null;
  let today = new Date();
  let yy, mm, dd;
  let today2, yy2, mm2, dd2;  // backwards growing period
  let today3, yy3, mm3, dd3;  // forwards harvest period
  let title2 = '', title3 = '';
  let layerName = '';
  let i;

  // set begining period
  yy = today.getFullYear();
  mm = today.getMonth();
  dd = today.getDate();
  if (dd<18) {
    today = new Date(yy, mm, 0); // set to last date of previous month
  } else {
    today = new Date(yy, mm, 15); // set to 01 - 15 of present month
  }
  activePeriod = activePeriod || 0;
  i = 0;
  while (i < 24) {
    yy = today.getFullYear();
    mm = today.getMonth();
    dd = today.getDate();
    today2 = today;
    if (dd==15) {
      // 01 - 15 of the month
      title2 = '01-15 ' + MONTHS[mm] + ' ' + (yy + 543);
      layerName = crop.toLowerCase() +  '_' + timeText(yy, mm, 15);
      today = new Date(yy, mm, 0);
    } else {
      // 16 - last date of previous month
      title2 = '16-' + dd + ' ' + MONTHS[mm] + ' ' + (yy + 543);
      layerName = crop.toLowerCase() +  '_' + timeText(yy, mm, dd);
      today = new Date(yy, mm, 15);
    }
    layer = {
      title: title2,
      mapSources: [
        Object.assign({}, MAP_SOURCES.ecoplant, {
        params: {
          //'TILED': true, //dont do this, it cachesssss!
          'LAYERS': 'ecoplant:' + layerName //workspace_name:layer_name
        },
        visible: (i==activePeriod)
      })],
      visible: (i==activePeriod),
      type: 'radio',
      radioGroup: 'ecoplant',
      checked: (i==activePeriod),
      active: (i==activePeriod),
      dense: true,
      showDivider: false
    };
    let legend = crop.match(/rice|maize/i) ? LEGEND08 : LEGEND24;
    layer.children = legend.map((legend,index) => {
      if (index==0) {
        return !crop.match(/maize/i) ? legend : {
          title: '(เริ่มปลูก / เก็บเกี่ยว)',
          style: {
            background: 'none'
          }
        };
      }
      let child = Object.assign({},legend);
      yy2 = today2.getFullYear();
      mm2 = today2.getMonth();
      dd2 = today2.getDate();
      if (dd2==15) {
        title2 = '01-15';
        today2 = new Date(yy2, mm2, 0);
        today3 = new Date(yy2,(mm2+3),15); // harvest date
        yy3 = today3.getFullYear();
        mm3 = today3.getMonth();
        dd3 = today3.getDate();
        title3 = '01-15';
      } else {
        title2 = '16-' + dd2;
        today2 = new Date(yy2, mm2, 15);
        today3 = new Date(yy2,(mm2+4),0); // harvest date
        yy3 = today3.getFullYear();
        mm3 = today3.getMonth();
        dd3 = today3.getDate();
        title3 = '16-' + dd3;
      }
      
      if (crop.match(/rice/i)) {
        title2 += ' ' + MONTHS[mm2] + ' ' + (yy2 + 543 - 2500);
        child.title = (<string>child.title).replace('weeks',title2);
      } else if (crop.match(/maize/i)) {
        title2 += ' ' + MONTHS[mm2] + ' ' + (yy2 + 543 - 2500);
        title3 += ' ' + MONTHS[mm3] + ' ' + (yy3 + 543 - 2500);
        child.title = title2 + ' / ' + title3;
      } else {
        title2 += ' ' + MONTHS[mm2] + ' ' + (yy2 + 543);
        child.title = title2;
      }
      return child;
    });
    layers.push(layer);
    i++;
  }

  crop = ('crop-' + crop.toLowerCase().replace('_','-')).toCamelCase();

  return {
    header: 'growingAreaEvery2Weeks',
    replacer: [crop],
    children: layers
  };
}

export function getMapLayers(crop,activePeriod?:number) : IMapLayer[] {
  return [getCropLayers(crop,activePeriod), BASEMAP_LAYERS[1]];
}

export function getDownloadLists(crop) : IMapLayer[] {
  let today = new Date();
  let yy, mm, dd;
  let latest
  // set begining period
  yy = today.getFullYear();
  mm = today.getMonth();
  dd = today.getDate();
  if (dd<18) {
    today = new Date(yy, mm, 0); // set to last date of previous month
  } else {
    today = new Date(yy, mm, 15); // set to 01 - 15 of present month
  }

  latest = today;

  if (!DOWNLOADS[0].children) {
    DOWNLOADS[0].children = [];
    while (today>=(new Date(2017,0,15))) {
      yy = today.getFullYear();
      mm = today.getMonth();
      dd = today.getDate();

      DOWNLOADS[0].children.push({
        uri: timeText(yy, mm, dd),
        title: dd + ' ' + MONTHS[mm] + ' ' + (yy + 543),
        type: 'radio',
        checked: false
      });
      if (dd==15) {
        today = new Date(yy, mm, 0);
      } else {
        today = new Date(yy, mm, 15);
      }
    }
    for (let i=1; i<DOWNLOADS.length; i++) {
      DOWNLOADS[i].children.unshift({
        header: 'latestUpdate',
        replacer: [latest]
      });
    }
  }

  if (crop.match(/^rice$/i)) {
    return DOWNLOADS;
  } else {
    return [
      DOWNLOADS[0],
      DOWNLOADS[1],
      DOWNLOADS[2]
    ];
  }
}

export function XXmakeCropLayer(crop:EEcoPlantType, data, index:number, isActive:boolean) : IMapLayer {
  let layer:IMapLayer = {
    title: data.data_label,
    mapSources: [
      Object.assign({}, MAP_SOURCES.ecoplant, {
      params: {
        //'TILED': true, //dont do this, it cachesssss!
        'LAYERS': 'ecoplant:' + crop + '_' + ('0' + index).slice(-2) // workspace:layer_name
      },
      visible: isActive // initial visibility when this layer is added to map
    })],
    visible: isActive,
    type: 'radio',
    radioGroup: 'ecoplant',
    checked: isActive,
    active: isActive,
    dense: true,
    showDivider: false
  };

  let date1, yy1, mm1, dd1;  // backwards growing period
  let date2, yy2, mm2, dd2;  // forwards harvest period
  let title1='', title2='';
  let i;

  date1 = createDate(data.data_date);
  let legend = crop.match(/rice|maize/) ? LEGEND08 : LEGEND24;
  layer.legend = legend.map((legend,index) => {
    if (index==0) {
      return !crop.match(/maize/i) ? legend : {
        title: '(เริ่มปลูก / เก็บเกี่ยว)',
        style: {
          background: 'none'
        }
      };
    }
    let child = Object.assign({},legend);
    yy1 = date1.getFullYear();
    mm1 = date1.getMonth();
    dd1 = date1.getDate();
    if (dd1==15) {
      title1 = '01-15';
      date1 = new Date(yy1, mm1, 0);
      date2 = new Date(yy1, (mm1 + 4), 15); // harvest date, 4 months in the future
      yy2 = date2.getFullYear();
      mm2 = date2.getMonth();
      dd2 = date2.getDate();
      title2 = '01-15';
    } else {
      title1 = '16-' + dd1;
      date1 = new Date(yy1, mm1, 15);
      date2 = new Date(yy1, (mm1+5), 0); // harvest date, 4 months in the future
      yy2 = date2.getFullYear();
      mm2 = date2.getMonth();
      dd2 = date2.getDate();
      title2 = '16-' + dd2;
    }
    
    if (crop.match(/rice/i)) {
      title1 += ' ' + MONTHS[mm1] + ' ' + (yy1 + 543 - 2500);
      child.title = (<string>child.title).replace('weeks', title1);
    } else if (crop.match(/maize/i)) {
      title1 += ' ' + MONTHS[mm1] + ' ' + (yy1 + 543 - 2500);
      title2 += ' ' + MONTHS[mm2] + ' ' + (yy2 + 543 - 2500);
      child.title = title1 + ' / ' + title2;
    } else {
      title1 += ' ' + MONTHS[mm1] + ' ' + (yy1 + 543);
      child.title = title1;
    }
    return child;
  });
  return layer;
}

export const makeCropLayer = function(crop:EEcoPlantType, data, index:number, isActive:boolean) : IMapLayer {
  let layer:IMapLayer = {
    title: data.data_label,
    mapSources: [{
      service: 'WMS',
      serverType: 'geoserver',
      params: {
        //'TILED': true, //dont do this, it cachesssss!
        LAYERS: 'ecoplant:' + crop + '_01'
      },
      /*layerOptions: {
        time: 'ecoplant:' + crop + '_' + ('0' + index).slice(-2) // real layers.
      },*/
      params2: {
        LAYERS: 'ecoplant:' + crop + '_' + ('0' + index).slice(-2), // real layers.
      },
      visible: isActive // initial visibility when this layer is added to map
    }],
    visible: isActive,
    type: 'radio',
    radioGroup: 'ecoplant',
    checked: isActive,
    active: isActive,
    dense: true,
    showDivider: false
  };

  let date1, yy1, mm1, dd1;  // backwards growing period
  let date2, yy2, mm2, dd2;  // forwards harvest period
  let title1='', title2='';
  let i;

  date1 = createDate(data.data_date);
  let legend = crop.match(/rice|maize/) ? LEGEND08 : LEGEND24;
  layer.legend = legend.map((legend,index) => {
    if (index==0) {
      return !crop.match(/maize/i) ? legend : {
        title: '(เริ่มปลูก / เก็บเกี่ยว)',
        style: {
          background: 'none'
        }
      };
    }
    let child = Object.assign({},legend);
    yy1 = date1.getFullYear();
    mm1 = date1.getMonth();
    dd1 = date1.getDate();
    if (dd1==15) {
      title1 = '01-15';
      date1 = new Date(yy1, mm1, 0);
      date2 = new Date(yy1, (mm1 + 4), 15); // harvest date, 4 months in the future
      yy2 = date2.getFullYear();
      mm2 = date2.getMonth();
      dd2 = date2.getDate();
      title2 = '01-15';
    } else {
      title1 = '16-' + dd1;
      date1 = new Date(yy1, mm1, 15);
      date2 = new Date(yy1, (mm1+5), 0); // harvest date, 4 months in the future
      yy2 = date2.getFullYear();
      mm2 = date2.getMonth();
      dd2 = date2.getDate();
      title2 = '16-' + dd2;
    }
    
    if (crop.match(/rice/i)) {
      title1 += ' ' + MONTHS[mm1] + ' ' + (yy1 + 543 - 2500);
      child.title = (<string>child.title).replace('weeks', title1);
    } else if (crop.match(/maize/i)) {
      title1 += ' ' + MONTHS[mm1] + ' ' + (yy1 + 543 - 2500);
      title2 += ' ' + MONTHS[mm2] + ' ' + (yy2 + 543 - 2500);
      child.title = title1 + ' / ' + title2;
    } else {
      title1 += ' ' + MONTHS[mm1] + ' ' + (yy1 + 543);
      child.title = title1;
    }
    return child;
  });

  //let layerStage = makeCropStageLayer(crop, data, index, false);
  return layer; //, layerStage];
}

export function makeCropOverallLayer(crop:EEcoPlantType, data, index:number, isActive:boolean) : IMapLayer {
  return {
    title: crop,
    mapSources: [
      Object.assign({}, MAP_SOURCES.ecoplant, {
      params: {
        //'TILED': true, //dont do this, it cachesssss!
        'LAYERS': 'ecoplant:' + crop + '_all_' + ('0' + index).slice(-2) // workspace:layer_name
      },
      visible: isActive // initial visibility when this layer is added to map
    })],
    visible: isActive,
    type: 'checkbox',
    checked: isActive,
    active: isActive,
    style: LEGEND_OVERALL[crop],
    dense: true,
    showDivider: false
  };
}

export function makeCropStageLayer(crop:EEcoPlantType, data, index:number, isActive:boolean) : IMapLayer {
  return {
    title: crop, //'การเจริญเติบโตในปัจจุบัน', //data.data_label,
    mapSources: [
      Object.assign({}, MAP_SOURCES.ecoplant, {
      params: {
        //'TILED': true, //dont do this, it cachesssss!
        'LAYERS': 'ecoplant:' + crop + '_stage_' + ('0' + index).slice(-2) // workspace:layer_name
      },
      visible: isActive // initial visibility when this layer is added to map
    })],
    visible: isActive,
    type: 'radio',
    radioGroup: 'ecoplant',
    checked: isActive,
    active: isActive,
    image: '/static/images/legend-polygon.svg',
    legend: LEGEND_STAGE[crop],
    dense: true,
    showDivider: false
  };
}

export function makeWateruseLayer(crop:EEcoPlantType) : IMapLayer {
  return {
    title: 'waterUseLayer',
    mapSources: [{
      service: 'WMS',
      serverType: 'geoserver',
      params: {
        //'TILED': true, //dont do this, it cachesssss!
        'LAYERS': 'ecoplant:wateruse_' + crop + '_present' //workspace_name:layer_name
      },
      //useGwc: true, //geoserver 2.12 has bug in GeoWebCache
      visible: false //display it after added to map
    }],
    geomType: 'Polygon',
    type: 'checkbox',
    checked: false,
    //image: '/static/images/legend-polygon.svg',
    dense: true,
    showDivider: false,
    legend: crop=='rice' ? LEGEND_WATER_USE : [{
      title: ['(','noData',')']
    }]
  };
}

export default BASEMAP_LAYERS;
